import { goto } from '$app/navigation';
import { stateTransitionDirection } from '$lib/states/transitionDirection.svelte';
import { tick } from 'svelte';

export const goToTransition = async (
  direction: 'left' | 'right',
  url: string | URL | null | undefined,
  opts?:
    | {
        replaceState?: boolean | undefined;
        noScroll?: boolean | undefined;
        keepFocus?: boolean | undefined;
        invalidateAll?: boolean | undefined;
        invalidate?: (string | URL | ((url: URL) => boolean))[] | undefined;
        state?: App.PageState | undefined;
      }
    | undefined,
) => {
  if (!url) {
    return;
  }

  stateTransitionDirection.set(direction);
  await tick();
  await goto(url, opts);

  await new Promise((resolve) => setTimeout(resolve, 400));

  stateTransitionDirection.set(null);
};
